export enum GetCalloutResponseWith {
  Answers = 'answers',
  Assignee = 'assignee',
  Callout = 'callout',
  Contact = 'contact',
  LatestComment = 'latestComment',
  Tags = 'tags',
}
